import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventContractProduct {
  externalId = ""
  category = ""
  underlyingProduct = ""
}

export const EVENT_CONTRACT_PRODUCT_DESER: SchemaDeSer<EventContractProduct> =
  new SchemaDeSerBuilder(EventContractProduct)
    .ofString("externalId", "external-id")
    .ofString("category")
    .ofString("underlyingProduct", "underlying-product")
    .toDeSer()

export class EventContractEvent {
  eventProductName = ""
  stopsTradingAt = ""
  settlementDate = ""
  symbol = ""
  title = ""
  eventProduct = new EventContractProduct()
}

export const EVENT_CONTRACT_EVENT_DESER: SchemaDeSer<EventContractEvent> =
  new SchemaDeSerBuilder(EventContractEvent)
    .ofString("eventProductName")
    .ofString("stopsTradingAt")
    .ofString("settlementDate")
    .ofString("symbol")
    .ofString("title")
    .ofNested(
      "eventProduct",
      EVENT_CONTRACT_PRODUCT_DESER,
      EventContractProduct
    )
    .toDeSer()

export class EventContractInstrument extends RestResource {
  symbol = ""
  instrumentType = ""
  contractSide = ""
  strikePrice = ""
  strikeType = ""
  description = ""
  streamerSymbol = ""
  event = new EventContractEvent()
}

export const EVENT_CONTRACT_INSTRUMENT_DESER: SchemaDeSer<EventContractInstrument> =
  new SchemaDeSerBuilder(EventContractInstrument)
    .ofString("symbol")
    .ofString("instrumentType")
    .ofString("contractSide")
    .ofString("strikePrice")
    .ofString("strikeType")
    .ofString("description")
    .ofString("streamerSymbol")
    .ofNested("event", EVENT_CONTRACT_EVENT_DESER, EventContractEvent)
    .toDeSer()
